<script>
    import Header from '../global/header.svelte'
    import Footer from '../global/footer.svelte'

    export let compSpread;
    export let termsURL;
    export let compTitle;

</script>

<style>


    section {
        text-align: center;
    }

    h1 {
        font-size:27px;
        font-size: 2.7rem;
        line-height: 27px;
        font-weight: 300;
    }

    section > div {
        padding: 5vw;
        min-height: 60vh;
        display: flex;
        align-items: center;
        justify-content: center; 
        text-align: center
    }

    .btn {
        max-width: 200px;
        margin: 10px auto 0 auto;
    }

   

</style>


<svelte:head>
    <title>{compTitle}</title>
</svelte:head>

<Header title="" url="/" /> 

<section>
    <div>
        <div>
            <h1>{compTitle}</h1>
            <p>Our competition will be running from the <strong>{compSpread}</strong>.</p>
            <p>For full terms and conditions please click <a target="_blank"  href="{termsURL}">here</a>.</p>
            <a class="btn" href="/">Back Home</a>
        </div>
    </div>
</section>

<Footer />
